import { Box, IconButton, SvgIcon, Typography } from '@mui/material';
import { FC } from 'react';
import CloseIcon from '../../../../../../../../../icons/svg/close.svg?react';
import FilterIcon from '../../../../../../../../../icons/svg/filter.svg?react';

type Props = {
  onClose: () => void;
};

export const TableRoofFilterDrawerHead: FC<Props> = ({ onClose }) => {
  return (
    <Box display={'flex'} justifyContent={'space-between'} sx={{ marginBottom: '20px' }}>
      <Box display={'flex'} alignItems={'center'}>
        <SvgIcon component={FilterIcon} sx={{ marginRight: '20px' }} />
        <Typography variant="h5">Filter</Typography>
      </Box>
      <Box>
        <IconButton onClick={onClose}>
          <SvgIcon component={CloseIcon} color="primary" />
        </IconButton>
      </Box>
    </Box>
  );
};
